import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import ModalComponent from "components/modalComponent/ModalComponent";
import connect from "react-redux/es/connect/connect";
import {
  setMenuLeftContent,
  setMenuLeftIndex,
  setMenuLeftItemIndex,
  setMenuTopIndex
} from "../../../redux/actions/menuActions";
import { Form } from "antd";
import ConfirmButton from "../../../components/buttons/ConfirmButton";
import { addPDC, removePDC } from "../../../redux/actions/sectorsActions";
import RemoveItem from "../../../components/manage/RemoveItem";
import Filter from "../../../components/manage/Filter";
import AuthRender from "../../AuthRender";
import { GSK_PHARMA_ID, SB1_ID } from "../../../configs/constants";

class ModalSectorPdcsManagement extends Component {
  constructor(props) {
    super(props);
    this.filter = null;
    this.state = { value: undefined };
  }

  spToLabel(sp = {}) {
    let label = sp.pdc_label || "";
    const adresse = sp.adresse || {};
    const cp = adresse.cp || sp.cp || "";

    if (cp) {
      label += ` (${cp})`;
    }
    if (
      this.props.currentClient &&
      (this.props.currentClient.id === GSK_PHARMA_ID || this.props.currentClient.id === SB1_ID)
    ) {
      const city = sp.city || "";
      const statut = sp.statut || "";
      const cip = sp.cip || "";
      if (city) label += ` (${city})`;
      if (statut) label += `-${statut}`;
      if (cip) label += `-${cip}`;
    }
    return label;
  }

  renderPDCItems() {
    const sector = this.props.currentSector || {};
    const pdcsSector = sector.salepoints || [];
    const items = [];
    for (let i = 0; i < pdcsSector.length; i++) {
      const pdcsSectorElement = pdcsSector[i];
      const label = this.spToLabel(pdcsSectorElement);
      items.push(
        <Fragment>
          <AuthRender service={5} forbidden_access={["modification"]}>
            <div className="p-al-full p-mrg-ver">
              <span>{label}</span>
            </div>
          </AuthRender>
          <AuthRender service={5} access={["modification"]}>
            <RemoveItem
              key={i}
              label={label}
              onClick={() => {
                this.props.removePDC(sector.sector_id, pdcsSectorElement.pdc_id);
              }}
            />
          </AuthRender>
        </Fragment>
      );
    }

    return items;
  }

  addPDC() {
    const value = this.filter.getValue();
    if (!value) return;
    const sector = this.props.currentSector || {};
    const sector_id = sector.sector_id || "";
    this.props.addPDC(sector_id, value);
    this.setState({
      value: ""
    });
    this.filter.reset();
  }

  render() {
    const { showModal, closeModal, title } = this.props;

    return (
      <ModalComponent title={title} showModal={showModal} closeModal={closeModal}>
        <AuthRender service={5} access={["modification"]}>
          <div className="p-al-full p-mrg-bot">
            <Filter
              ref={elt => {
                this.filter = elt;
              }}
              match={(searchValue = "", element = {}) => {
                const currentElements = this.props.currentSector.salepoints || [];
                const formattedElement = this.spToLabel(element);

                return (
                  _.findIndex(currentElements, { pdc_id: element.pdc_id }) === -1 &&
                  formattedElement.toUpperCase().indexOf(searchValue.toUpperCase()) !== -1
                );
              }}
              elements={this.props.pdcs}
              currentElements={this.props.currentSector.salepoints}
              elementKey={"pdc_id"}
              onSelect={v => {
                this.setState({ value: v }, () => {});
              }}
              format={v => {
                return this.spToLabel(v);
              }}
              selectProps={{
                placeholder: "Sélectionnez un PDC",
                notFoundContent: "Aucun PDC disponible"
              }}
              nbItems={20}
              selectProps={{ style: { width: "70%" } }}
            />

            <ConfirmButton label={"Ajouter"} large={true} onClick={() => this.addPDC()} />
          </div>
        </AuthRender>

        <div className="p-modal-scrollcontent">{this.renderPDCItems()}</div>
      </ModalComponent>
    );
  }
}

ModalSectorPdcsManagement.propTypes = {
  showModal: PropTypes.boolean,
  closeModal: PropTypes.function,
  data: PropTypes.array,
  title: PropTypes.string
  // children? JSX
};

const mapStateToProps = (state, ownProps) => {
  const sector_id = ownProps.sector_id;
  const sectors = state.sectors || {};
  const sectorsList = sectors.sectorsList || [];
  const currentSector = _.find(sectorsList, { sector_id: sector_id }) || {};
  currentSector.salepoints = currentSector.salepoints || [];
  return {
    pdcs: sectors.pdcs,
    currentSector: currentSector,
    currentClient: state.currentClient
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setMenuTopIndex: index => {
      dispatch(setMenuTopIndex(index));
    },
    setMenuLeftContent: index => {
      dispatch(setMenuLeftContent(index));
    },
    setMenuLeftIndex: index => {
      dispatch(setMenuLeftIndex(index));
    },
    setMenuLeftItemIndex: index => {
      dispatch(setMenuLeftItemIndex(index));
    },
    addPDC: (sector_id, pdc_id) => {
      dispatch(addPDC(sector_id, pdc_id));
    },
    removePDC: (sector_id, pdc_id) => {
      dispatch(removePDC(sector_id, pdc_id));
    }
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(ModalSectorPdcsManagement));

//export default ModalSectorPdcsManagement;



// WEBPACK FOOTER //
// src/containers/metier/sectors/ModalSectorPdcsManagement.js